import { Box, Grid, Hidden, Typography } from "@mui/material";
import HeaderTitle from "../common/HeaderTitle";
import { Container } from "@mui/system";

export default function PageLayout({ title, Icon, children, subtitle }) {
  return (
    <Container sx={{ pl: { md: "100px" }, mt: 3, mb: 2 }}>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          className="page-header-container"
          sx={{
            padding: 3,
            height: "80px",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Hidden mdUp>
            <Icon style={{ color: "#eaad32", fontSize: 38 }} />
          </Hidden>
          <Hidden smDown>
            <Icon style={{ color: "#eaad32", fontSize: 32 }} />
          </Hidden>
          <HeaderTitle title={title} />
        </Grid>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </Container>
  );
}
